<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    window.addEventListener('beforeunload',()=>{
      sessionStorage.setItem('state',JSON.stringify(this.$store.state));
    })
  },
  created() {
    if ( sessionStorage.getItem('state') ) {
      this.$store.replaceState( Object.assign( {}, this.$store.state, JSON.parse(sessionStorage.getItem('state') )));
    }
  }
}
</script>

